import script from "./expenses-report.vue?vue&type=script&setup=true&lang=js"
export * from "./expenses-report.vue?vue&type=script&setup=true&lang=js"

import "./expenses-report.vue?vue&type=style&index=0&id=b1d732fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1d732fe"]])

export default __exports__